import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import type { StarfishIconRef } from '@/app/common/icons/starfish';
import { FACILITIES } from '@/app/components/search/utils/FacilitiesType.ts';
import type { ProductAccommodationFacilities } from '@/domainLogic/types/typesProduct.ts';

export const getIcon = (facility: FACILITIES): StarfishIconRef | undefined => {
  if (facility === FACILITIES.SEAFRONT)
    return { category: 'Services', name: 'icon-island', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.SPA)
    return { category: 'Services', name: 'icon-wellness', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.SWIMMING_POOL)
    return { category: 'Services', name: 'icon-swimming-pool', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.PARKING)
    return { category: 'Services', name: 'icon-parking', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.FREE_WIFI)
    return { category: 'Services', name: 'icon-wifi', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.CHILDREN)
    return { category: 'Services', name: 'icon-child', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.ADULTS_ONLY)
    return { category: 'Services', name: 'icon-adults-only', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.ENTERTAINMENT)
    return { category: 'Services', name: 'icon-entertainment', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.PETS_ALLOWED)
    return { category: 'Services', name: 'icon-pawn', color: 'iconSecondary' } as const;
  if (facility === FACILITIES.KITCHEN)
    return { category: 'Services', name: 'icon-oven', color: 'iconSecondary' } as const;
  return undefined;
};

export const getText = (facility: FACILITIES, t: TranslationFunction): string | undefined => {
  if (facility === FACILITIES.SEAFRONT) return t('vacation.search.filters.facilities.options.seafront');
  if (facility === FACILITIES.SPA) return t('vacation.search.filters.facilities.options.spa');
  if (facility === FACILITIES.SWIMMING_POOL) return t('vacation.search.filters.facilities.options.swimmingpool');
  if (facility === FACILITIES.PARKING) return t('vacation.search.filters.facilities.options.parking');
  if (facility === FACILITIES.FREE_WIFI) return t('vacation.search.filters.facilities.options.freewifi');
  if (facility === FACILITIES.CHILDREN) return t('vacation.search.filters.facilities.options.children');
  if (facility === FACILITIES.ADULTS_ONLY) return t('vacation.search.filters.facilities.options.adultsonly');
  if (facility === FACILITIES.ENTERTAINMENT) return t('vacation.search.filters.facilities.options.entertainment');
  if (facility === FACILITIES.PETS_ALLOWED) return t('vacation.search.filters.facilities.options.pets');
  if (facility === FACILITIES.KITCHEN) return t('vacation.search.filters.facilities.options.kitchen');
  return undefined;
};

export const getActiveFacilities = (
  facilities: ProductAccommodationFacilities,
  whitelist: FACILITIES[]
): FACILITIES[] => {
  const keys = Object.keys(facilities);

  return whitelist.filter((feature) => {
    const isFacilityEnabled = keys.includes(feature);
    const isFacilityActive = facilities[feature] === true;
    return isFacilityEnabled && isFacilityActive;
  });
};
